export type UseIconMetatagsProps = {
  enabled: boolean;
  favicons: Array<{ fullName: string; name: string; }>;
  site: any;
}

export function useIconMetatags({ enabled, favicons, site }: UseIconMetatagsProps) {
  if (!enabled) {
    return <></>
  }

  const elements = favicons.map((i) => (
    <link
      key={`icon-${i.name}`}
      rel='icon'
      href={`/assets/${site.slug}/favicons/${i.fullName}`}
      sizes={i.name}
      type='image/png'
    />
  ))

  return elements
}